<!--
- Generic Modal > More About Priority Support 
-->

<template>
	<generic-modal-wrap modal-id="MoreAboutPrioritySupport">
		<h2 class="nodal-title">
			Priority Support
		</h2>

		<div class="ratio ratio-16x9 mb-2">
			<iframe src="//www.youtube.com/embed/ZRvA2Ah1y14?autoplay=1&rel=0" frameborder="0" allowfullscreen />
		</div>
		
		<p class="mb-0">
			If the video doesn't appear, click this link to watch it on Youtube:<br />
			<a href="//www.youtube.com/watch/ZRvA2Ah1y14" target="_blank" rel="noopener noreferrer">http://www.youtube.com/watch?v=ZRvA2Ah1y14</a>
		</p>

	</generic-modal-wrap>
</template>

<script>
import GenericModalWrap from '@/components/modals/GenericWrap.vue';

export default {
	name: 'ModalMoreAboutPrioritySupport',
	components:{
		GenericModalWrap
	},
}
</script>

